import { render, staticRenderFns } from "./Bbquery.vue?vue&type=template&id=d41f8a48&scoped=true"
import script from "./Bbquery.vue?vue&type=script&lang=js"
export * from "./Bbquery.vue?vue&type=script&lang=js"
import style0 from "./Bbquery.vue?vue&type=style&index=0&id=d41f8a48&prod&scoped=true&lang=css"
import style1 from "./Bbquery.vue?vue&type=style&index=1&id=d41f8a48&prod&lang=css"
import style2 from "./Bbquery.vue?vue&type=style&index=2&id=d41f8a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41f8a48",
  null
  
)

export default component.exports